module.exports = "<div class=\"loading-content d-flex justify-content-center align-items-center\">\n<div class=\"text-center\">\n  <img src=\"assets/blocks.svg\"/>\n  <p>{{progress * 100 | number : '1.0-0' }}%</p>\n</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/loading/loading.component.html
// module id = ./src/app/loading/loading.component.html
// module chunks = main